import React from 'react';

export default function TopRightNav() {
  return (
    <div className="top-right-nav">
      {/* Invite Button */}
      <button className="invite-button">
        <span>✦</span>
        Invite a friend
      </button>

      {/* Icons and Avatar */}
      <div className="icons">
        <i className="bi bi-archive" title="Archive"></i>
        <i className="bi bi-grid" title="Dashboard"></i>

        <div className="avatar">J</div>
      </div>
    </div>
  );
}
